import React from 'react';
import { getTrack } from '../../helpers';

const track = getTrack({ block: 33 });

export default function Serivce({ mobile = false }) {
  return (
    <div className="stage stage-service border-top-grey" data-track={track}>
      <div className="ac-service-content">
        <ul>
          <li className="ac-service-offline text-center">
            <b className="iconfont-symbol-products ico-offline-store"></b> <h3>线下购买</h3>
            <p>到vivo零售店亲身体验各种产品，我们还将为您解答各种问题。</p>
            <div className="ext-more-link">
              <a
                className="line-link"
                href="https://www.vivo.com.cn/store"
                data-track='{"type":"click","params":{"pageview":"官网系列详情页","cfrom":"2210","name":"X60 Pro+","series":"X系列","position":"33","pointsname":"查询网点"}}'
              >
                查询网点
              </a>
            </div>
          </li>
          <li className="ac-service-dividedpay text-center">
            <b className="iconfont-symbol-products ico-dividedPay"></b> <h3>分期付款</h3> <p>花呗分期最低享0利率，0服务费。</p>
            <div className="ext-more-link">
              <a
                className="line-link"
                href="https://shop.vivo.com.cn/product/10006210"
                data-track='{"type":"click","params":{"pageview":"官网系列详情页","cfrom":"2211","name":"X60 Pro+","series":"X系列","position":"33","pointsname":"分期购买"}}'
              >
                分期购买
              </a>
            </div>
          </li>
          <li className="ac-service-support text-center">
            <b className="iconfont-symbol-products ico-service-support"></b> <h3>服务支持</h3>
            <p>为节省您的时间，您可以在自助服务中查找您所需的服务，我们将竭诚为您服务。</p>
            <div className="ext-more-link">
              <a
                className="line-link"
                href="http://kefu.vivo.com.cn/robot-vivo/pcChat.html"
                data-track='{"type":"click","params":{"pageview":"官网系列详情页","cfrom":"2212","name":"X60 Pro+","series":"X系列","position":"33","pointsname":"开始交流"}}'
              >
                开始交流
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}
